import { Navigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth'
import { FullPageSkeleton } from '@/ui/components'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth()

  // Show loading spinner while auth is initializing
  if (isLoading) {
    return <FullPageSkeleton />
  }

  // If not authenticated, but tokens exist, we're restoring session -> show loader instead of redirecting
  const hasStoredSession = (() => {
    try {
      return !!localStorage.getItem('access_token') && !!localStorage.getItem('refresh_token')
    } catch {
      return false
    }
  })()

  if (!user || !isAuthenticated) {
    if (hasStoredSession) {
      return <FullPageSkeleton />
    }
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
